import React, {useEffect, useState} from "react";
import "./Modal.css";
import {motion, useAnimation, useDragControls} from "framer-motion";
import {isNotchedPhoneFromApple} from "./utils";

let Modal = (props) => {
    let [state, setState] = useState("");
    let [deba, setDe] = useState(1);
    let [height, setHeight] = useState(0);
    let variants = useAnimation();
    const dragControls = useDragControls()

    function startDrag(event) {
        dragControls.start(event, { snapToCursor: false })
    }

    useEffect(()=>{
        setHeight(document.getElementById('content').clientHeight);
        if (document.getElementById('content').clientHeight > window.innerHeight) {
            //Если высота контента больше экрана, то открываем модалку на высоте 1/2 экрана
            variants.start({
                height:(window.innerHeight/2)+document.getElementById('header').clientHeight,
                y:isNotchedPhoneFromApple() ? -21 : 0,
                opacity:1,
                scale:1,
            })
            setState("half")
            setDe(0);
        }
        else {
            //Иначе - ставим высоту контента
            variants.start({
                height:document.getElementById('content').clientHeight,
                y:isNotchedPhoneFromApple() ? -21 : 0,
                opacity:1,
                scale:1
            })
            setState("half")
            setDe(1);
        }
    },[props.title, variants])

    function onPan(event, info) {
        if (info.offset.y > 10) {
            if (state === "half") {
                variants.start({
                    height:0
                }).then(()=>{
                    props.callback();
                })
            }
            else if (state === "full") {
                variants.start({
                    height:((window.innerHeight/2)+document.getElementById('header').clientHeight),
                    y:isNotchedPhoneFromApple() ? -21 : 0,
                })
                setState("half")
            }
        }
        else if (info.offset.y < 10) {
            if (deba !== 1) {
                variants.start({
                    height:window.innerHeight-24,
                })
                setState("full")
            }
            else {
                setState("half")
            }
        }
    }

    return (
        <motion.div
            initial={{y:height, opacity:0}}
            animate={variants}
            style={{bottom:0}}
            className="Modal"
            id="content"
            dragControls={dragControls}

        >
            <motion.div id="header"
                        drag="y"
                        dragConstraints={{top:0, bottom:0}}
                        dragElastic={0.05}
                        onDragEnd={onPan}
                        onMouseDown={startDrag}
                        className="Modal--title">
                <div className="Modal--hand"/>
                <div className="Modal--title-text">{props.title}</div>
            </motion.div>
            <div className="Modal--content">
                {props.children}
            </div>

        </motion.div>
    )
}
export default Modal;
